import { IModel } from '../interfaces/imodel';

export class MensagemMuralModel implements IModel {

    public mensagemMuralId = 0;

    public tipoMensagemMuralId = 0;

    public textoConteudoMensagemMural = '';

    public textoFonteOrigemMensagemMural = '';

    public statusExibirMensagemMural = 0;

    public dataCadastroMensagemMural: Date = null;

    public dataInicioExibicaoMensagemMural: Date = null;

    public dataFimExibicaoMensagemMural: Date = null;

    public textoTituloMensagemMural = '';

    public dataAtualizacao: Date = null;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/mensagem-mural.model.ts